import Resource from './Resource';

/**
 * Document Resource
 */
class Document extends Resource
{
    constructor() {
        super('document', ['documents']);
    }

    unassociated(params = {}) {
        return this._doGet('unassociated', params);
    }

    emptyTrash() {
        return this._doDelete('empty-trash');
    }

    restore(uuid) {
        return this._doPost([uuid, 'restore'])
    }

    upload(source, type, description = null, progress = null) {
        let data = new FormData();

        data.append('document', source, source.name);
        data.append('type', type);
        data.append('description', description);

        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        if (progress) {
            config.onUploadProgress = progress;
        }

        return this.store(data, {}, config);
    }

    associate(id, owner, type, description, order) {
        return this._doPost([id, 'associate'], { 
            owner: owner.type + ':' + owner.id, 
            type,
            description,
            order
        });
    }
}   

export let DocumentResource = new Document();

/**
 * DocumentSchema
 * @param {Object} defaults [description]
 */
export let DocumentSchema = function(defaults = {}) {
    let schema = {
        id: null,
        uuid: null,
        filename: null,
        type: null,
        description: null,
        mime: null,
        disk: null,
        order: null,
        size: null,
        owner_type: null,
        owner_id: null,
        preview_url: null,
        view_url: null,
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
};

export let DocumentTypes = {
    TYPE_OTHER: 'other',
    TYPE_TASK_DOCUMENT: 'task_document',
    TYPE_INSTANCE_IMAGE: 'image',
    TYPE_INSTANCE_DOCUMENT: 'document',
    TYPE_MESSAGING_ATTACHMENT: 'messaging_attachment',
    TYPE_INSPECTION_IMAGE: 'inspection_image',
    TYPE_SIGNABLE_DOCUMENT: 'signable_document',
};

export let ImageAspectList = [
    'Front Three Quarter',
    'Rear Three Quarter',
    'Exterior Front',
    'Exterior Rear',
    'Exterior Detail',
    'Engine',
    'Wheel',
    'Exterior Profile',
    'Dashboard',
    'Interior Front',
    'Interior Rear',
    'Interior Detail',
    'Boot',
    'Other Aspect',
];

export let DocumentDescriptionList = [
    'V5 Front',
    'V5 Internal',
    'Service History',
    'MOT',
    'HPI Certificate',
    'Purchase Invoice',
    'Check In Sheet',
    'Receipt',
    'Settlement Letter',
    'Other Document Type',
];